import { colors } from '@lmc/common/constants'
import { Icon } from '../../../../../components/generic'
import { Popover } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { getShowAlert } from '../EMARResidentStockScreenV2/utils'
import { ResidentMedication } from '../types'

type StockAlertIconProps = {
  medication: ResidentMedication
}

export const StockAlertIcon = ({ medication }: StockAlertIconProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  const { stockAlertLevel } = medication
  const showAlert = getShowAlert(medication)

  return (
    <Popover
      content={showAlert ? t('STOCK_LEVEL_LOW') : t('STOCK_LEVEL_OK')}
      placement="top"
    >
      <div style={{ height: 24, marginLeft: 10 }}>
        <Icon
          name={showAlert ? 'incident' : 'tick-in-circle'}
          fill={
            stockAlertLevel
              ? showAlert
                ? colors.red
                : colors.successgreen
              : undefined
          }
          size={24}
        />
      </div>
    </Popover>
  )
}

export default StockAlertIcon
